import React from "react"
import { DualDropdown } from "buoy-core"
import styled from "styled-components"
import { injectIntl, defineMessages } from "react-intl"

const amountArray = [...Array(100)].map((a, i) => ({
  value: i + 1,
  text: `${i + 1}`,
}))

const unitMessages = defineMessages({
  minutes: {
    id: "duration.minutes",
    defaultMessage: "{value, plural, one {minute} other {minutes}}",
  },
  hours: {
    id: "duration.hours",
    defaultMessage: "{value, plural, one {hour} other {hours}}",
  },
  days: {
    id: "duration.days",
    defaultMessage: "{value, plural, one {day} other {days}}",
  },
  weeks: {
    id: "duration.weeks",
    defaultMessage: "{value, plural, one {week} other {weeks}}",
  },
  months: {
    id: "duration.months",
    defaultMessage: "{value, plural, one {month} other {months}}",
  },
  years: {
    id: "duration.years",
    defaultMessage: "{value, plural, one {year} other {years}}",
  },
})

const units = (value, formatMessage) => [
  {
    value: "minutes",
    text: formatMessage(unitMessages.minutes, { value }),
  },
  {
    value: "hours",
    text: formatMessage(unitMessages.hours, { value }),
  },
  {
    value: "days",
    text: formatMessage(unitMessages.days, { value }),
  },
  {
    value: "weeks",
    text: formatMessage(unitMessages.weeks, { value }),
  },
  {
    value: "months",
    text: formatMessage(unitMessages.months, { value }),
  },
  {
    value: "years",
    text: formatMessage(unitMessages.years, { value }),
  },
]

const TimeSelectWrapper = styled.div`
  margin: 6px 0;
`

const TimeSelect = ({ duration, onDurationChange, onUnitChange, intl }) => {
  const { formatMessage } = intl
  return (
    <TimeSelectWrapper>
      <DualDropdown
        widthLeft="30%"
        optionsLeft={amountArray}
        valueLeft={parseInt(duration.amount, 10)}
        onChangeLeft={onDurationChange}
        placeholderLeft=""
        optionsRight={units(parseInt(duration.amount, 10), formatMessage)}
        valueRight={duration.unit}
        onChangeRight={onUnitChange}
        placeholderRight=""
        widthRight="70%"
      />
    </TimeSelectWrapper>
  )
}

export default injectIntl(TimeSelect)



// WEBPACK FOOTER //
// ./assets/common/components/TimeSelect.js